import React from "react";
import { Controller } from "react-hook-form";
import TextField from "./TextField";
import { getValueFromObject } from "../../utils/basic";

/**
 * @param {import("@mui/material").TextFieldProps} params
 * @returns
 */
const ControlledTextField = ({
  formProps,
  name,
  validationKey,
  ignoreError = false,
  ...otherProps
}) => {
  const {
    control,
    formState: { errors },
    rules,
  } = formProps;

  const isError =
    (getValueFromObject(errors, name) !== undefined && !ignoreError) ||
    otherProps.error;

  return (
    <Controller
      name={name}
      control={control}
      disabled={otherProps.disabled}
      rules={
        otherProps.disabled
          ? { a: () => true }
          : getValueFromObject(rules, validationKey ?? name)
      }
      render={({ field: { onChange, onBlur, value } }) => (
        <TextField
          {...otherProps}
          value={value}
          error={isError}
          helperText={
            !isError
              ? otherProps.helperText
              : !ignoreError
              ? getValueFromObject(errors, name)?.message ??
                otherProps.helperText
              : undefined
          }
          onChange={(v) => {
            onChange(v);
            if (!!otherProps.onChange) {
              otherProps.onChange(v);
            }
          }}
          onBlur={(e) => {
            onBlur();
            if (!!otherProps.onBlur) {
              otherProps.onBlur(value, e);
            }
          }}
        />
      )}
    />
  );
};

export default ControlledTextField;
